import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { Currency } from '../models/currency.model';

@Injectable()
export class CurrencyService {

  getDefaultCurrency(): Observable<Currency> {
    return this.http.get<Currency>(this.urlBuilder.getUrl('currency/default'));
  }

  getCurrencies(): Observable<Currency[]> {
    return this.http.get<Currency[]>(this.urlBuilder.getUrl('currency/all'));
  }

  getCurrencyByCode(code: string): Observable<Currency> {
    const apiUrl = this.urlBuilder.getUrl(`currency/by_code/${code}`);
    return this.http.get<Currency>(apiUrl);
  }

  constructor(
    private readonly urlBuilder: UrlBuilderService,
    private readonly http: HttpClient) { }

}
